// The ONLY source of colour, type and timing for the verification overlay.
//
// Declared here because T6, T10 and T11 all consume it; without fixed names
// three tickets would invent three vocabularies. No component may hardcode a
// hex value after this ticket — every colour, size, weight and timing the
// glyph, chart and modal use comes from this module.
//
// Visual direction (plan Architecture §6): a broadcast quality-control
// instrument, not a crypto dashboard and not a trading chart.

export const color = {
  ink: '#08131A',   // panel ground, ~88% opaque + backdrop blur
  bed: '#12242E',   // the chart's own field
  rule: '#1E3B48',  // hairline grid, dividers
  bone: '#DCE7EA',  // text — cool off-white, never pure #fff
  jade: '#3FBF9B',  // a verified slice — desaturated on purpose
  alarm: '#FF5238', // a mismatch — hot orange-red, sits with the jade
  brand: '#76B89C', // the FileFidelity heading — sampled from Gavin's 16 Oct mock
} as const

export const font = {
  // Open Sans for all prose, sentence case, no all-caps labels.
  prose: '"Open Sans", ui-sans-serif, system-ui, sans-serif',
  // IBM Plex Mono for one job only — hexadecimal fingerprints, account
  // addresses, the slice counter. Fixed-width there is functional, so no
  // monospace anywhere else.
  mono: '"IBM Plex Mono", ui-monospace, monospace',
} as const

export const weight = {
  regular: 400,
  medium: 500,
  semibold: 600,
} as const

export const size = {
  // px
  count: 30,
  brand: 24,        // the FileFidelity heading
  summary: 20,
  title: 15,
  body: 13,
  label: 12,
  mono: 12,
} as const

export const space = {
  // px
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
} as const

export const motion = {
  columnPrintMs: 120,  // a new column growing from the baseline
  failureFadeMs: 400,  // the surface fading out behind the modal
  glyphPulseMs: 1400,  // the alarm-state V
} as const

/** True when the viewer has asked for reduced motion. Every animation in
 * this module's consumers checks it. */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
